import { useIntl } from "react-intl";
import Section from "../../common/section";
import { SwitchInput, TextAreaInput, TextInput } from "../../common/fields";
import { Field } from "react-final-form";

import * as Validations from "../../common/form/validator";

// Custom validator for comma-separated domains
const validateAllowedEmailDomains = (value) => {
  if (!value || value.trim() === "*" || value.trim() === "") return undefined;
  // Split by comma, trim spaces
  const domains = value.split(",").map((d) => d.trim());
  // Regex for valid domain (simple version)
  const domainRegex = /^(?!-)[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/;
  for (let domain of domains) {
    if (!domainRegex.test(domain)) {
      return "Invalid domain format. Use comma-separated domains like example.com,example.org";
    }
  }
  return undefined;
};

const SelfRegistrationForm = ({ disabled }) => {
  const intl = useIntl();
  return (
    <div className="flex flex-column gap-2">
      <Section title="self_registration_settings">
        <div className="grid">
          <div className="col-12 md:col-4">
            <Field
              name="isSelfRegistrationEnabled"
              component={SwitchInput}
              type="checkbox"
              label={intl.formatMessage({
                id: "is_self_registration_enabled",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "is_self_registration_enabled",
              })}
            />
          </div>
          <div className="col-12 md:col-4">
            <Field
              name="allowedEmailDomains"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "allowed_email_domains",
              })}
              infoMessage="self_registration_domain_info"
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "allowed_email_domains",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                validateAllowedEmailDomains
              )}
            />
          </div>
          <div className="col-12 md:col-4">
            <Field
              name="isEmailVerificationRequired"
              component={SwitchInput}
              type="checkbox"
              label={intl.formatMessage({
                id: "is_email_verification_required",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "is_email_verification_required",
              })}
            />
          </div>
          <div className="col-12">
            <Field
              name="instructions"
              component={TextAreaInput}
              label={intl.formatMessage({
                id: "instructions",
              })}
              infoMessage="self_registration_instructions_info"
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "instructions",
              })}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default SelfRegistrationForm;
